import { useState } from 'react';
import { Box, Drawer, createTheme, ThemeProvider, Grid } from '@mui/material';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ProjectsProvider } from './providers/ProjectsProvider';
import { AuthProvider } from './providers/AuthProvider';
import Header from './components/Header/Header';
import DrawerContent from './components/DrawerContent/DrawerContent';
import Dashboard from './Pages/Dashboard/Dashboard';
import Projects from './Pages/Projects/Projects';
import ProjectEdit from './Pages/Projects/ProjectEdit';
import Slider from './Pages/Slider/Slider';
import SliderEdit from './Pages/Slider/SliderEdit';
import Pages from './Pages/Pages/Pages';
import PageEdit from './Pages/Pages/PageEdit';
import Blocks from './Pages/Blocks/Blocks';
import SiteSettings from './Pages/SiteSettings/SiteSettings';
import './assets/scss/typography.css';
import Login from './Pages/Login/Login';
import { SecureZone } from './components/SecureZone/SecureZone';
import useMouseTracker from './hooks/useMouseTracker';

const AppLayout = ({ open, setOpen }) => {
  const location = useLocation();
  const isLoginPage = location.pathname === '/' || location.pathname === '/login';

  if (isLoginPage) {
    return <Login />;
  }

  return (
    <>
      <Header setOpen={setOpen} open={open} />
      <Grid container sx={{ padding: '0 1.5rem' }}>
        <Box sx={{ paddingTop: '2rem' }}>
          <Drawer open={open} onClose={() => setOpen(false)} sx={{ width: '320px' }}>
            <DrawerContent setOpen={setOpen} open={open} />
          </Drawer>
          <Routes>
            <Route path="/site-dash" element={<SecureZone component={Dashboard} />} />
            <Route path="/projects/" element={<SecureZone component={Projects} />} />
            <Route path="/project-edit" element={<SecureZone component={ProjectEdit} />} />
            <Route path="/pages" element={<SecureZone component={Pages} />} />
            <Route path="/page-edit" element={<SecureZone component={PageEdit} />} />
            <Route path="/sliders" element={<SecureZone component={Slider} />} />
            <Route path="/slider-edit" element={<SecureZone component={SliderEdit} />} />
            <Route path="/blocks" element={<SecureZone component={Blocks} />} />
            <Route path="/site-settings" element={<SecureZone component={SiteSettings} />} />
          </Routes>
        </Box>
      </Grid>
    </>
  );
};

const App = () => {
  const [open, setOpen] = useState(false);
  const theme = createTheme({
    shape: {
      borderRadius: '10px',
    },
    palette: {
      primary: {
        main: '#344a9d',
        light: '#3d5dce',
        dark: '#a0b3f6',
        contrastText: '#fff'
      },
      secondary: {
        main: '#349d85',
        light: '#54debd',
        dark: '#1e5c4e',
        contrastText: '#fff'
      },
    }
  });

  useMouseTracker();

  return (
    <BrowserRouter basename="/">
      <AuthProvider setOpen={setOpen} open={open}>
        <ThemeProvider theme={theme}>
          <ProjectsProvider>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/*" element={<AppLayout open={open} setOpen={setOpen} />} />
            </Routes>
          </ProjectsProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
